<template>
  <div class="mainSection">
    <div class="container">
      <Interface
        v-if="this.localStorage.mobile"
        :buttons="buttons"
        :key="this.localStorage.mobile.last_update"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Interface from 'components/setting/interface/Interface'
export default {
  name: 'settingInterfaceMob',
  components: { Interface },
  data() {
    return {}
  },
  created() {
    if (
      !this.localStorage.mobile ||
      this.localStorage.mobile.language_id !== $cookies.get('languageSelect').id
    ) {
      this.onTranslationsAllPage({
        language_id: $cookies.get('languageSelect').id,
        storage: this.localStorage,
        type: 'mobile',
      })
    } else {
      this.onTranslationsLastUpdate({
        language_id: $cookies.get('languageSelect').id,
        type: 'email',
      }).then((resp) => {
        if (resp !== this.localStorage.mobile.last_update) {
          this.onTranslationsAllPage({
            language_id: $cookies.get('languageSelect').id,
            storage: this.localStorage,
            type: 'mobile',
          })
        }
      })
    }
  },
  methods: {
    ...mapActions('translations', ['onTranslationsAllPage', 'onTranslationsLastUpdate']),
  },
  computed: {
    buttons() {
      return [
        {
          text: this.localStorage.mobile.pages['mob_menu'].buttons.menyu,
          icon: 'interface-menu',
          link: 'settingInterfaceMob_menu',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMob_menu_buttons',
            },
          ],
        },
        {
          text: this.localStorage.mobile.pages['mob_login'].labels.vhod,
          icon: 'interface-login',
          link: 'settingInterfaceMob_login',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMob_login_buttons',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.inputs,
              icon: 'interface-common-inputs',
              link: 'settingInterfaceMob_login_inputs',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.labels,
              icon: 'interface-common-labels',
              link: 'settingInterfaceMob_login_labels',
            },
          ],
        },
        {
          text: this.localStorage.mobile.pages['mob_restore'].labels['vosstanovlenie-parolya'],
          icon: 'interface-restore',
          link: 'settingInterfaceMob_restore',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMob_restore_buttons',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.inputs,
              icon: 'interface-common-inputs',
              link: 'settingInterfaceMob_restore_inputs',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.labels,
              icon: 'interface-common-labels',
              link: 'settingInterfaceMob_restore_labels',
            },
          ],
        },
        {
          text: this.localStorage.mobile.pages['mob_registration'].titles['sozdanie-parolya'],
          icon: 'interface-registration',
          link: 'settingInterfaceMob_registration',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.titles,
              icon: 'interface-common-titles',
              link: 'settingInterfaceMob_registration_titles',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.labels,
              icon: 'interface-common-labels',
              link: 'settingInterfaceMob_registration_labels',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMob_registration_buttons',
            },
          ],
        },
        {
          text: this.localStorage.mobile.pages['mob_invitation'].titles['priglashenie-v-proapp'],
          icon: 'interface-employee-invite',
          link: 'settingInterfaceMob_invitation',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.titles,
              icon: 'interface-common-titles',
              link: 'settingInterfaceMob_invitation_titles',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.labels,
              icon: 'interface-common-labels',
              link: 'settingInterfaceMob_invitation_labels',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMob_invitation_buttons',
            },
          ],
        },
        {
          text: this.localStorage.mobile.pages['mob_personal_area'].titles['lichnyy-kabinet'],
          icon: 'pages-settings-personal_area',
          link: 'settingInterfaceMob_personalArea',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.titles,
              icon: 'interface-common-titles',
              link: 'settingInterfaceMob_personalArea_titles',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.sections,
              icon: 'interface-common-sections',
              link: 'settingInterfaceMob_personalArea_sections',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.labels,
              icon: 'interface-common-labels',
              link: 'settingInterfaceMob_personalArea_labels',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMob_personalArea_buttons',
            },
          ],
        },
        {
          text: this.localStorage.mobile.pages['mob_menu'].buttons['calendar'],
          icon: 'pages-projects-statistic',
          link: 'settingInterfaceMob_calendar',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.labels,
              icon: 'interface-common-labels',
              link: 'settingInterfaceMob_calendar_labels',
            },
          ],
        },
        {
          text: this.localStorage.mobile.pages['mob_menu'].buttons['kontrol-rabochego-vremeni'],
          icon: 'pages-projects-statistic',
          link: 'settingInterfaceMob_workingTime',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.titles,
              icon: 'interface-common-titles',
              link: 'settingInterfaceMob_workingTime_titles',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.texts,
              icon: 'interface-common-text',
              link: 'settingInterfaceMob_workingTime_text',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMob_workingTime_buttons',
            },
            {
              text: this.localStorage.mobile.pages['mob_working_time-report'].titles['otchety'],
              icon: 'interface-common-reports',
              link: 'settingInterfaceMob_workingTimeReport',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.titles,
                  icon: 'interface-common-titles',
                  link: 'settingInterfaceMob_workingTimeReport_titles',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.sections,
                  icon: 'interface-common-sections',
                  link: 'settingInterfaceMob_workingTimeReport_sections',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.labels,
                  icon: 'interface-common-labels',
                  link: 'settingInterfaceMob_workingTimeReport_labels',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.buttons,
                  icon: 'interface-common-buttons',
                  link: 'settingInterfaceMob_workingTimeReport_buttons',
                },
              ],
            },
          ],
        },
        {
          text: this.localStorage.translations.pages['pages'].buttons['proekty'],
          icon: 'pages-projects',
          link: 'settingInterfaceMob_projects',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.sections,
              icon: 'interface-common-sections',
              link: 'settingInterfaceMob_projects_sections',
            },
          ],
        },
        {
          text: this.localStorage.mobile.pages['agreement'].labels['name_agreement'],
          icon: 'pages-projects-statistic',
          link: 'settingInterfaceMob_workingTime',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.labels,
              icon: 'interface-common-labels',
              link: 'settingInterfaceMob_agreement_labels',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMob_agreement_buttons',
            },
          ],
        },
        {
          text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
          icon: 'interface-common-dialogs',
          link: 'settingInterfaceMob_modal',
          childrens: [
            {
              text: this.localStorage.mobile.pages['mob_modal'].add_photo['dobavit-foto'],
              icon: 'interface-common-add_photo',
              link: 'settingInterfaceMob_modal_addPhoto',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.elements,
              icon: 'interface-common',
              link: 'settingInterfaceMob_modal_common',
            },
          ],
        },
        {
          text: this.localStorage.translations.pages.setting.pages['push_notifications'],
          icon: 'pages-settings-push_notifications',
          link: 'settingInterfaceMob-push',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.labels,
              icon: 'interface-common-labels',
              link: 'settingInterfaceMob-push-labels',
            },
          ],
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>
